<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [phoneNumber]="phoneNumber"
  [heroVideo]="heroVideo"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">

  <!-- Tab Navigation -->
  <div class="devis-tabs-container">
    <nav class="devis-tabs">
      <a *ngFor="let tab of devisTabs" 
         [routerLink]="tab.route" 
         routerLinkActive="active"
         class="tab-item">
        <i class="pi" [ngClass]="tab.icon"></i>
        <span>{{ tab.label }}</span>
      </a>
    </nav>
  </div>

  <!-- Intro Section -->
  <div class="intro-section">
    <h2 class="intro-title">
      Changez d'assurance crédit et économisez <span class="highlight-yellow">50%</span> sur vos mensualités
    </h2>
    <p class="intro-text">
      Profitez de la nouvelle <span class="loi-lemoine">Loi LEMOINE</span>, gagnez du temps en comparant plus de 10 assureurs Emprunteur et obtenez 3 devis les moins chers en moins de 30 secondes
    </p>
  </div>

  <!-- Comparaison Form Component -->
  <app-comparaison></app-comparaison>

</app-page-layout>
